import { goblinProportions } from './goblin.js';
import { humanProportions, type HumanProportions } from './human.js';
import { morphOrcProportions, orcProportions } from './orc.js';
import { elfProportions, morphElfProportions } from './elf.js';
import { dwarfProportions, morphDwarfProportions } from './dwarf.js';
import { celestialProportions, morphCelestialProportions } from './celestial.js';
import { halflingProportions, morphHalflingProportions } from './halfling.js';

/** Ancestry anatomy for the shared humanoid frame. Human face variants remain render-time warps of the authored base. */
export function humanoidAnatomy(ancestry = 'human', rig?: string, faceId?: string): HumanProportions {
  if (ancestry === 'goblin') return goblinProportions(rig, faceId);
  if (ancestry === 'orc') return morphOrcProportions(orcProportions(rig), faceId);
  if (ancestry === 'elf') return morphElfProportions(elfProportions(rig), faceId);
  if (ancestry === 'dwarf') return morphDwarfProportions(dwarfProportions(rig), faceId);
  if (ancestry === 'celestial') return morphCelestialProportions(celestialProportions(rig), faceId);
  if (ancestry === 'halfling') return morphHalflingProportions(halflingProportions(rig), faceId);
  if (ancestry === 'human') return humanProportions(rig);
  throw new Error(`No humanoid anatomy registered for ancestry '${ancestry}'.`);
}
